var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.selectedStudent
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c("parent-home-page", {
                  attrs: { students: _vm.$store.state.students }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectLocale
        ? [
            _c(
              "modal",
              {
                attrs: {
                  "modal-title": _vm.$t(
                    "MAIN_CONTENT.General.languageSelectionTitle"
                  ),
                  show: _vm.selectLocale,
                  "dialog-size": "sm",
                  name: "courseRequestModal"
                },
                on: {
                  close: function($event) {
                    _vm.selectedLocale.length === 0 ? "" : _vm.saveLocale()
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(modalProps) {
                        return [
                          _c("p", { staticClass: "text-center text-muted" }, [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.General.languageSelectionTitle"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _vm.showLocaleSaveError
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 alert alert-danger" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "faExclamationTriangle" }
                                  }),
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.HomePage.localeSaveError"
                                        )
                                      ) +
                                      "\n\t\t\t\t"
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c("strong", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.General.selectLanguage"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedLocale,
                                    expression: "selectedLocale"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "localeSelection",
                                  id: "localeSelect"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedLocale = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.General.languageSelectionTitle"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.locales, function(
                                  locale,
                                  localeIndex
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: "locale_" + localeIndex,
                                      domProps: { value: locale.LOCALE_ID }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(locale.LOCALE_DISPLAY_TEXT) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2506353399
                )
              },
              [
                _vm._v(" "),
                _c("template", { slot: "footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-transparent pull-right",
                      attrs: {
                        type: "button",
                        disabled: _vm.selectedLocale.length <= 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveLocale()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.commonContent.submitButton")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedStudent
        ? [
            _vm.roleRules.COVID19_SURVEY_LINK === "Y" &&
            _vm.selectedStudent.RESTRICTED_ACCOUNT_FLG === "N" &&
            !!_vm.covidLink
              ? _c("div", [
                  _c("div", { staticClass: "col-sm-12 alert alert-warning" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.HomePage.CovidSurveyMessage")
                        )
                    ),
                    _c(
                      "a",
                      { attrs: { href: _vm.covidLink, target: "_blank" } },
                      [_vm._v("COVID-19 Daily Screening")]
                    ),
                    _vm._v(".\n\t\t\t")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.BUILDING_NEWS_FLG === "Y" && _vm.announcements.length
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [
                      _c("announcements", {
                        attrs: {
                          title: _vm.$t(
                            "MAIN_CONTENT.Announcements.labelAnnouncements"
                          ),
                          announcements: _vm.announcements,
                          "show-dismiss": false
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.assignments.length > 0 &&
            (_vm.role === "student" || !!_vm.selectedStudent) &&
            _vm.owlKey > 0
              ? _c(
                  "div",
                  { key: "assignment_" + _vm.owlKey, staticClass: "row" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 class-page" },
                      [
                        _c(
                          "panel-basic",
                          {
                            staticClass: "class-assignments",
                            attrs: {
                              title: _vm.$t(
                                "MAIN_CONTENT.HomePage.upcomingAssignments"
                              ),
                              id: "assignments",
                              collapsable: false,
                              panelClass: "owl-heading",
                              overflow: "hidden"
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.commonContent.classPage_upcomingAssignments"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                ),
                                _c(
                                  "small",
                                  { staticStyle: { "text-transform": "none" } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.commonContent.classPage_upcomingAssignmentTotal",
                                            { count: _vm.assignments.length }
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm.dueSoon.length
                                      ? [_vm._v(" | ")]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.dueSoon.length
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip.top-center",
                                                value: {
                                                  content: _vm.$t(
                                                    "commonText.dueSoonTextDescription"
                                                  ),
                                                  trigger: "hover click"
                                                },
                                                expression:
                                                  "{content: $t('commonText.dueSoonTextDescription'), trigger: 'hover click'}",
                                                modifiers: {
                                                  "top-center": true
                                                }
                                              }
                                            ],
                                            staticClass: "text-danger"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AssignmentsCarousel.classPage_dueSoon",
                                                    {
                                                      count: _vm.dueSoon.length
                                                    }
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "view-options" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-transparent",
                                  class: {
                                    active: _vm.assignmentsView === "slider"
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.assignmentsView = "slider"
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-columns",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.classPage.index.classPage_sliderView"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-transparent",
                                  class: {
                                    active: _vm.assignmentsView === "grid"
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.assignmentsView = "grid"
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-th",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.classPage.index.classPage_gridView"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-transparent",
                                  class: {
                                    active: _vm.assignmentsView === "list"
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.assignmentsView = "list"
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-th-list",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.classPage.index.classPage_listView"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.assignments.length &&
                            _vm.assignmentsView === "slider"
                              ? _c("assignments-carousel", {
                                  attrs: {
                                    "carousel-class":
                                      "assignments-carousel color-status " +
                                      _vm.getDisplayStyle,
                                    "carousel-data": _vm.assignments,
                                    "carousel-id": "ac-cwp-01",
                                    "color-variant": "blank",
                                    margin: 10,
                                    "show-nav": true,
                                    "show-course": false
                                  }
                                })
                              : _vm.assignments.length &&
                                _vm.assignmentsView === "grid"
                              ? _c("assignments-grid", {
                                  attrs: {
                                    "grid-class":
                                      "assignments-grid color-status",
                                    "grid-data": _vm.assignments,
                                    "grid-id": "ag-cwp-01",
                                    "show-course": false
                                  }
                                })
                              : _vm.assignments.length &&
                                _vm.assignmentsView === "list"
                              ? _c("assignments-list", {
                                  attrs: {
                                    "list-class":
                                      "assignments-list color-status",
                                    "list-data": _vm.assignments,
                                    "list-id": "al-cwp-01",
                                    "show-course": false
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "flex-equal-heights" }, [
                _vm.roleRules.COURSE_REQUESTS_FLG === "Y" &&
                _vm.courseRequestForms.length > 0 &&
                (_vm.role === "student" || !!_vm.selectedStudent)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-lg-6 course-request-form-panel",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "panel-basic",
                          {
                            attrs: {
                              id: "request-form",
                              collapsable: false,
                              "panel-class": "full-height course-request-height"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "btn btn-primary btn-lg btn-block text-lg",
                                attrs: { to: "/course-request-forms" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.nextYearCourseRequestFormButton"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.roleRules.GRAD_PROG_FLG === "Y" &&
                _vm.roleRules.GRAD_COURSE_WORK === "Y" &&
                (_vm.role === "student" || !!_vm.selectedStudent)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-lg-6 graduation-progress-panel",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "panel-basic",
                          {
                            attrs: {
                              title: _vm.$t(
                                "MAIN_CONTENT.HomePage.graduationProgressLabel"
                              ),
                              id: "grad-progress",
                              collapsable: false,
                              "panel-class": "full-height"
                            }
                          },
                          [
                            _c("div", { staticClass: "col-xs-10" }, [
                              _c("div", { staticClass: "progress" }, [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top-center",
                                      value: {
                                        content: _vm.$t(
                                          "MAIN_CONTENT.HomePage.completed",
                                          { percent: _vm.percentCreditsEarned }
                                        ),
                                        trigger: "hover click"
                                      },
                                      expression:
                                        "{content: $t('MAIN_CONTENT.HomePage.completed', { percent: percentCreditsEarned } ), trigger: 'hover click'}",
                                      modifiers: { "top-center": true }
                                    }
                                  ],
                                  staticClass:
                                    "progress-bar completed-progress-bar",
                                  style: {
                                    width: "" + _vm.percentCreditsEarned
                                  },
                                  attrs: {
                                    role: "progressbar",
                                    "aria-valuenow": _vm.percentCreditsEarned,
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top-center",
                                      value: {
                                        content: _vm.$t(
                                          "MAIN_CONTENT.HomePage.inProgress",
                                          {
                                            percent:
                                              _vm.percentCreditsInProgress
                                          }
                                        ),
                                        trigger: "hover click"
                                      },
                                      expression:
                                        "{content: $t('MAIN_CONTENT.HomePage.inProgress', { percent: percentCreditsInProgress } ), trigger: 'hover click'}",
                                      modifiers: { "top-center": true }
                                    }
                                  ],
                                  staticClass:
                                    "progress-bar in-progress-background",
                                  style: {
                                    width: "" + _vm.percentCreditsInProgress
                                  },
                                  attrs: {
                                    role: "progressbar",
                                    "aria-valuenow":
                                      _vm.percentCreditsInProgress,
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-2" }, [
                              _c("span", { staticClass: "text-lg" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.percentCreditsEarned) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.interactiveSchedules.length > 0 &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-scheduler",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.interactiveSchedulesLabel"
                      ),
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "hand-pointer",
                      "heading-level": 2,
                      titleAsLink: true,
                      panelLinkAddress: "/interactive-scheduler/"
                    }
                  },
                  [
                    _c("table", { staticClass: "table table-striped" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th"),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.HomePage.windowOpenUntilLabel"
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.interactiveSchedules, function(
                          schedule,
                          index
                        ) {
                          return _c(
                            "tr",
                            { key: "interactive_schedules_" + index },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.routeToSchedule(
                                          schedule.ISCHED_VIEW_CODE
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(schedule.SCHOOL_TITLE) +
                                        " - " +
                                        _vm._s(schedule.ISCHED_VIEW_DESC) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("datetime")(
                                        schedule.STUDENT_WINDOW_END,
                                        "MMMM, DD YYYY HH:mm:ss",
                                        "MM/DD/YYYY h:mm a"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.dataVerificationForms
              ? [
                  _vm.showFormsBlock(_vm.dataVerificationForms) &&
                  (_vm.role === "student" || !!_vm.selectedStudent)
                    ? _c(
                        "panel-plain",
                        {
                          attrs: {
                            id: "panel-awaiting-completion",
                            title: _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.sideMenuStudentDataFormsLink"
                            ),
                            "show-button": false,
                            "panel-class": "dash-student",
                            "icon-class": "edit",
                            "heading-level": 2
                          }
                        },
                        [
                          _vm.showAwatingCompletion(_vm.dataVerificationForms)
                            ? _c(
                                "table",
                                { staticClass: "table table-striped" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.formsAwaitingCompletionTitleCase"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.HomePage.windowOpenUntilLabel"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.dataVerificationForms.ONE_TIME_FORMS,
                                      function(form, idx) {
                                        return _c(
                                          "tr",
                                          {
                                            key:
                                              "data_verification_forms_" + idx
                                          },
                                          [
                                            (_vm.role === "student" &&
                                              form.STUDENT_ACCESS_FLG ===
                                                "Y") ||
                                            (_vm.role === "parent" &&
                                              form.PARENT_ACCESS_FLG === "Y")
                                              ? [
                                                  _c("td", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.goToForm(
                                                              form
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              form.DV_FORM_NAME
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    form.FORM_STATUS_FLG === "O"
                                                      ? _c("i", [
                                                          _c("small", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.HomePage.formStarted"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    form.DV_FORM_NAME !==
                                                    form.DV_FORM_DESC
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                form.DV_FORM_DESC
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("datetime")(
                                                            form.DV_FORM_END_DT,
                                                            "MMMM, DD YYYY HH:mm:ss",
                                                            "MM/DD/YYYY h:mm a"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataVerificationForms.PENDINGFORMS.length > 0
                            ? _c(
                                "table",
                                { staticClass: "table table-striped" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.pendingFormLabel"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.submittedTitleCase"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.dataVerificationForms.PENDINGFORMS,
                                      function(form, idx) {
                                        return _c(
                                          "tr",
                                          {
                                            key:
                                              "data_verification_forms_" + idx
                                          },
                                          [
                                            (_vm.role === "student" &&
                                              form.STUDENT_ACCESS_FLG ===
                                                "Y") ||
                                            (_vm.role === "parent" &&
                                              form.PARENT_ACCESS_FLG === "Y")
                                              ? [
                                                  _c("td", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.goToForm(
                                                              form
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              form.DV_FORM_NAME
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    form.DV_FORM_NAME !==
                                                    form.DV_FORM_DESC
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                form.DV_FORM_DESC
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("datetime")(
                                                            form.SUBMITTED_DATE,
                                                            "MMMM, DD YYYY HH:mm:ss",
                                                            "MM/DD/YYYY h:mm a"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataVerificationForms.RECENTLY_COMPLETED_FORMS
                            .length > 0
                            ? _c(
                                "table",
                                { staticClass: "table table-striped" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.recentFormLabel"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.status"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.dataVerificationForms
                                        .RECENTLY_COMPLETED_FORMS,
                                      function(form, idx) {
                                        return _c(
                                          "tr",
                                          {
                                            key:
                                              "data_verification_forms_" + idx
                                          },
                                          [
                                            (_vm.role === "student" &&
                                              form.STUDENT_ACCESS_FLG ===
                                                "Y") ||
                                            (_vm.role === "parent" &&
                                              form.PARENT_ACCESS_FLG === "Y")
                                              ? [
                                                  _c("td", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.goToForm(
                                                              form
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              form.DV_FORM_NAME
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    form.DV_FORM_NAME !==
                                                    form.DV_FORM_DESC
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                form.DV_FORM_DESC
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          form.FORM_STATUS_FLG ==
                                                            "A"
                                                            ? _vm.$t(
                                                                "MAIN_CONTENT.StudentDataForms.approvedTitleCase"
                                                              )
                                                            : _vm.$t(
                                                                "MAIN_CONTENT.StudentDataForms.declinedTitleCase"
                                                              )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.REPORTS_FLG === "Y" &&
            _vm.schoolPostings.length > 0 &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-school-postings",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.recentSchoolPostingsLabel"
                      ),
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "edit",
                      "heading-level": 2
                    }
                  },
                  [
                    _c("table", { staticClass: "table table-striped" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("MAIN_CONTENT.HomePage.itemLabel"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.HomePage.postedLabel")
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.schoolPostings, function(post, index) {
                          return _c(
                            "tr",
                            { key: "recent_school_posting_" + index },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "pointer",
                                    attrs: {
                                      href: post.REPORT_URL,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(post.REPORT_TITLE) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(post.MODIFIED_DATE))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.ATTENDANCE_FLG === "Y" &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-attendance",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.recentAttendanceLabel"
                      ),
                      titleAsLink: true,
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "check",
                      "heading-level": 2,
                      "show-footer": false,
                      panelLinkAddress: "/attendance/"
                    }
                  },
                  [
                    _c("p", [
                      _c(
                        "em",
                        [
                          _vm.attendance.length
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.showingAttendanceFromPastSevenDaysLabel"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.noAttendanceFromPastSevenDaysLabel"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ],
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.seeAllAttendance()
                                }
                              }
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.seeAllLabel")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.attendance.length
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.dateLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.dayLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.HomePage.attendanceDescriptionLabel"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm.roleRules.ATTENDANCE_MINUTES_FLG === "Y"
                                ? _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.HomePage.tardyMinutesLabel"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.roleRules.ATTENDANCE_COMMENTS_FLG === "Y"
                                ? _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.HomePage.commentsLabel"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.attendance, function(attendance) {
                              return _c("tr", { key: attendance.DATE }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        attendance.DATE,
                                        "MMMM, DD YYYY HH:mm:ss"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("day")(
                                        attendance.DATE,
                                        "MMMM, DD YYYY HH:mm:ss"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(attendance.ATTENDANCE_CODE) +
                                      " - " +
                                      _vm._s(attendance.ATTENDANCE_CODE_DESC)
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.roleRules.ATTENDANCE_MINUTES_FLG === "Y"
                                  ? _c("td", [
                                      _vm._v(_vm._s(attendance.TARDY_MINUTES))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.roleRules.ATTENDANCE_COMMENTS_FLG === "Y"
                                  ? _c("td", [
                                      _vm._v(_vm._s(attendance.COMMENTS))
                                    ])
                                  : _vm._e()
                              ])
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.GRADES_FLG === "Y" &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-grade-updates",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.recentGradeUpdatesLabel"
                      ),
                      titleAsLink: true,
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "book",
                      "heading-level": 2,
                      "show-footer": false,
                      panelLinkAddress: "/courses-grades/"
                    }
                  },
                  [
                    _c("p", [
                      _c(
                        "em",
                        [
                          _vm.gradeUpdates.length
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.HomePage.showingGradeUpdatesFromThePastSevenDays"
                                    )
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.HomePage.noGradeUpdatesFromThePastSevenDays"
                                    )
                                  )
                                )
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.gradeUpdates.length
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.HomePage.gradeMarkingPeriodLabel"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.classLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.updatedLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.teacherLabel")
                                  )
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.gradeUpdates, function(grade, index) {
                              return _c(
                                "tr",
                                { key: "recent_grade_updates_" + index },
                                [
                                  !!grade.PWP_RUNNING_GRADE_CODE &&
                                  !!grade.COURSE_SECTION_GUID
                                    ? [
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: {
                                                    name:
                                                      "ClassPageGradesBreakdown",
                                                    params: {
                                                      courseSectionGUID:
                                                        grade.COURSE_SECTION_GUID
                                                    },
                                                    query: {
                                                      studentRid:
                                                        grade.STUDENT_RID,
                                                      mpCode: grade.MP_CODE
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      grade.GRADE_TO_SHOW
                                                    ) +
                                                    " (" +
                                                    _vm._s(grade.MP_CODE) +
                                                    ")\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: {
                                                    name: "ClassPageHome",
                                                    params: {
                                                      courseSectionGUID:
                                                        grade.COURSE_SECTION_GUID
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      grade.COURSE_SECTION_TITLE
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("datetime")(
                                                grade.LAST_CALCULATED_DATE,
                                                "MMMM, DD YYYY HH:mm:ss",
                                                "MM/DD/YYYY h:mm a"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(grade.TEACHER_NAME))
                                        ])
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.GRADES_FLG === "Y" &&
            _vm.classPostings.length > 0 &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-class-postings",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.recentClassPostingsLabel"
                      ),
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "calendar-alt",
                      "heading-level": 2,
                      titleAsLink: true,
                      panelLinkAddress: "/courses-grades"
                    }
                  },
                  [
                    _c("table", { staticClass: "table table-striped" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("MAIN_CONTENT.HomePage.itemLabel"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("MAIN_CONTENT.HomePage.classLabel"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.HomePage.postedLabel")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.HomePage.teacherLabel")
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.classPostings, function(posting, index) {
                          return _c(
                            "tr",
                            { key: "recent_class_postings_" + index },
                            [
                              _vm.getPostingIcon(posting).length > 0
                                ? [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "max-width": "700px" },
                                        on: {
                                          clicked: function($event) {
                                            posting.CLICKED = !posting.CLICKED
                                          }
                                        }
                                      },
                                      [
                                        _vm.getPostingIcon(posting) !== "folder"
                                          ? _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _vm.getPostingIcon(
                                                  posting
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.getPostingIcon(posting) ===
                                          "folder" && posting.CLICKED
                                          ? _c("font-awesome-icon", {
                                              attrs: { icon: "folder" }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.getPostingIcon(posting) ===
                                          "folder" && !posting.CLICKED
                                          ? _c("font-awesome-icon", {
                                              attrs: { icon: "folder-open" }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "F"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: posting.REPORT_URL,
                                                    target: "_blank"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.logClassPageActivity(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !!posting.FORUM_ID
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.goToForum(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        posting.REPORT_NAME
                                                      ) +
                                                      " \n\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  posting.NEW_POST_FLG === "Y"
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "*New Posts!"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "D"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.goToAssignmentBin(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        posting.REPORT_NAME
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "P"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.goToSubpage(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "H"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      "header"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "E"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: posting.REPORT_URL,
                                                    target: "_blank"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.logClassPageActivity(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "O"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.toggleFolder(
                                                        posting.LINE_NO
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isFolderOpen(
                                                        posting.LINE_NO
                                                      ),
                                                      expression:
                                                        "isFolderOpen(posting.LINE_NO)"
                                                    }
                                                  ]
                                                },
                                                _vm._l(posting.FILES, function(
                                                  file
                                                ) {
                                                  return _c(
                                                    "li",
                                                    { key: file.REPORT_ID },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            target: "_blank",
                                                            href:
                                                              file.REPORT_URL
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.CONTENT_FILENAME
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "G"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.goToGlossary(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        posting.REPORT_NAME
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "L"
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: posting.LINK_LOCATION,
                                                    target: "_blank"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.logClassPageActivity(
                                                        posting
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(posting.REPORT_NAME)
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_TYPE === "" ||
                                        posting.REPORT_TYPE === "A"
                                          ? [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(posting.REPORT_NAME) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        posting.REPORT_DESCRIPTION.length > 0 &&
                                        !(
                                          posting.REPORT_TYPE === "P" ||
                                          posting.REPORT_TYPE === "H"
                                        )
                                          ? [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticStyle: {
                                                  "font-size": "11px"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getString(
                                                      posting.REPORT_DESCRIPTION
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "ClassPageHome",
                                                params: {
                                                  courseSectionGUID:
                                                    posting.COURSE_SECTION_GUID
                                                }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  posting.COURSE_SECTION_TITLE
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("datetime")(
                                              _vm.getPostDate(posting),
                                              "MMMM, DD YYYY HH:mm:ss",
                                              "ddd - MM/DD/YY"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(posting.TEACHER_NAME) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.DISCIPLINE_FLG === "Y" &&
            (_vm.role === "student" || _vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-discipline",
                      title: _vm.$t(
                        "MAIN_CONTENT.HomePage.recentDisciplineLabel"
                      ),
                      titleAsLink: true,
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "gavel",
                      "heading-level": 2,
                      "show-footer": false,
                      panelLinkAddress: "/discipline/"
                    }
                  },
                  [
                    _c("p", [
                      _c(
                        "em",
                        [
                          Object.keys(_vm.discipline).length
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.showingDisciplineFromThePastSevenDays"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.noDisciplineFromThePastSevenDays"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ],
                          _vm._v(" "),
                          _c("router-link", { attrs: { to: "/discipline" } }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("MAIN_CONTENT.HomePage.seeAllLabel")
                                )
                              )
                            ])
                          ])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    Object.keys(_vm.discipline).length
                      ? _c(
                          "table",
                          { staticClass: "table table-striped" },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("MAIN_CONTENT.HomePage.dateLabel")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.commonContent.schoolLabel"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.roleRules.DISCIPLINE_INFRACTION_FLG === "Y"
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.HomePage.infractionsLabel"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.roleRules.DISCIPLINE_ACTION_FLG === "Y"
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.HomePage.actionsTakenLabel"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.discipline, function(
                              incidentsForSchool,
                              schoolId
                            ) {
                              return _c(
                                "tbody",
                                { key: schoolId },
                                _vm._l(incidentsForSchool, function(incident) {
                                  return _c(
                                    "tr",
                                    { key: incident.INCIDENT_RID },
                                    [
                                      _c("td", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(incident.INCIDENT_DATE) +
                                            " " +
                                            _vm._s(incident.INCIDENT_TIME) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(incident.SCHOOL_TITLE) +
                                            " "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.roleRules
                                        .DISCIPLINE_INFRACTION_FLG === "Y"
                                        ? _c(
                                            "td",
                                            [
                                              Object.keys(incident.INFRACTIONS)
                                                .length > 1
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "-25px"
                                                      }
                                                    },
                                                    _vm._l(
                                                      incident.INFRACTIONS,
                                                      function(infraction) {
                                                        return _c(
                                                          "li",
                                                          { key: infraction },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  infraction
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : Object.keys(
                                                    incident.INFRACTIONS
                                                  ).length === 1
                                                ? [
                                                    _vm._v(
                                                      _vm._s(
                                                        incident.INFRACTIONS[1]
                                                      )
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.roleRules.DISCIPLINE_ACTION_FLG ===
                                      "Y"
                                        ? _c(
                                            "td",
                                            [
                                              Object.keys(incident.ACTIONS)
                                                .length > 1
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "-25px"
                                                      }
                                                    },
                                                    _vm._l(
                                                      incident.ACTIONS,
                                                      function(action) {
                                                        return _c(
                                                          "li",
                                                          { key: action },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(action) +
                                                                "\n\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : Object.keys(incident.ACTIONS)
                                                    .length === 1
                                                ? [
                                                    _vm._v(
                                                      _vm._s(
                                                        incident.ACTIONS[1]
                                                      )
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.roleRules.FEES_FLG === "Y" &&
            (_vm.role === "student" || !!_vm.selectedStudent)
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-fees",
                      title: _vm.$t("MAIN_CONTENT.HomePage.recentFeesLabel"),
                      titleAsLink: true,
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "piggy-bank",
                      "heading-level": 2,
                      "show-footer": false,
                      panelLinkAddress: "/fees/"
                    }
                  },
                  [
                    _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
                      ? _c("h4", [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.HomePage.balanceOwedToSchoolLabelNoProp"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "strong",
                            { class: { "text-danger": _vm.feesBalance > 0 } },
                            [_vm._v(_vm._s(_vm._f("dollar")(_vm.feesBalance)))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.district.CWP_ALLOW_PAYMENTS_FLG == "Y"
                      ? _c("payment-portal", {
                          attrs: { balance: _vm.externalFeesBalance }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
                      ? _c("p", [
                          _c(
                            "em",
                            [
                              _vm.fees.length
                                ? [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.HomePage.showingTransactionsFromThePastSevenDaysLabel"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.HomePage.noTransactionsFromThePastSevenDaysLabel"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ],
                              _vm._v(" "),
                              _c("router-link", { attrs: { to: "/fees" } }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.HomePage.seeAllLabel"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.fees.length &&
                    _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.dateLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.typeLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.HomePage.feesLabel")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.HomePage.paymentsLabel"
                                    )
                                  )
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.recentFees, function(fee) {
                              return _c("tr", { key: fee.TRANS_ID }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        fee.TRANS_DATE,
                                        "MMMM, DD YYYY",
                                        "MM/DD/YYYY"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(fee.STUD_FEE_CAT_DESC))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    fee.TRANS_TYPE === "FEE" ||
                                    fee.TRANS_TYPE === "REFUND"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dollar")(fee.TRANS_AMOUNT)
                                            )
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    fee.TRANS_TYPE === "PAYMENT" ||
                                    fee.TRANS_TYPE === "DEPOSIT"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dollar")(
                                                fee.TRANS_AMOUNT * -1
                                              )
                                            )
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.lunchMenus && _vm.lunchMenus.length
              ? _c(
                  "panel-plain",
                  {
                    attrs: {
                      id: "panel-lunch-menu",
                      title: _vm.$t("MAIN_CONTENT.HomePage.lunchMenuLabel"),
                      "show-button": false,
                      "panel-class": "dash-student",
                      "icon-class": "utensils",
                      "heading-level": 2,
                      titleAsLink: true,
                      panelLinkAddress: "/lunch-menus"
                    }
                  },
                  [
                    typeof _vm.lunchMenus !== "undefined" &&
                    _vm.lunchMenus !== null &&
                    _vm.lunchMenus.length > 0
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.allStudentSchools, function(
                            school,
                            schoolIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: "lunchMenu_school_" + schoolIndex,
                                staticClass: "col-xs-12"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("div", { staticClass: "col-xs-12" }, [
                                      _c("h4", [
                                        _vm._v(_vm._s(school.SCHOOL_TITLE))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.lunchMenus, function(
                                      menu,
                                      index
                                    ) {
                                      return [
                                        menu.SCHOOL_ID === school.SCHOOL_ID
                                          ? _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "week-item col-xs-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "panel panel-neutral"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "panel-heading"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "datetime"
                                                                )(
                                                                  menu.LUNCH_DATE,
                                                                  "MMMM, DD YYYY HH:mm:ss",
                                                                  "dddd - MM/DD/YYYY"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "panel-body",
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-line"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              menu.LUNCH_MENU
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }),
                                    _vm._v(" "),
                                    !_vm.schoolsWithMenus.includes(
                                      school.SCHOOL_ID
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "col-xs-12" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.HomePage.nothingForThisWeek"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }